import { useEffect, useRef } from 'react';

/** Runs `onRequest` each time `request` changes from the value last seen; the initial value is not a request. */
export const useRequestEffect = (request: number | undefined, onRequest: () => void) => {
  const seenRef = useRef(request);
  useEffect(() => {
    if (request === undefined || request === seenRef.current) return;
    seenRef.current = request;
    onRequest();
  }, [onRequest, request]);
};
